<script setup lang="ts">
import { t } from '../i18n';
import { settings } from '../platform';
import Icon from './Icon.vue';
import ObjectTree from './ObjectTree.vue';

/** Floating object tree card (§6.9), shown on demand. */
</script>

<template>
  <aside class="float card tree-card" :aria-label="t('tree.title')" @pointerdown.stop>
    <header>
      <strong><Icon name="tree" :size="15" />{{ t('tree.title') }}</strong>
      <button class="icon-btn" :aria-label="t('common.close')" @click="settings.treeOpen = false"><Icon name="close" :size="14" /></button>
    </header>
    <ObjectTree />
  </aside>
</template>

<style scoped>
.tree-card {
  top: 64px;
  left: 76px;
  width: 290px;
  max-height: calc(100% - 140px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 0 16px;
}
header strong {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
}
header .icon-btn {
  width: 26px;
  height: 26px;
}
</style>
